//import '../../css/base.css';
import './ChangeTicketType.css';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import 'select2/dist/css/select2.min.css';
import 'select2/dist/js/select2.min.js';
import moment from 'moment';
import { FilterTypesTicketsFirebird } from 'components/FilterTypesTickets/FilterTypesTickets';

const common = require('../common/common');
const env = require("../../config.js").default;
const multibrand = require('../common/multibrand.js');

class ChangeTicketType extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.state.pageContent = this.props.pageContent
        this.state.tipologie_ticket_attive = this.props.tipologie_ticket_attive
        this.state.marcaDefault = this.props.marcaDefault
        this.state.newTipoTicket = ""
        this.state.subType = this.props.subType
        this.state.tipoTicket = this.props.tipoTicket
    }

    changeSelect2Value(){
        const $ = window.$;
        var fieldPrefix = "modal_new_";
        var campiTicket = this.state.tipologie_ticket_attive[this.state.tipoTicket];
        if (this.state.tipoTicket){
            return campiTicket.campi.map((index, key) => {
                let description = this.state.pageContent.BDOCU;
                let value = description[key].value;
                if (index.html.indexOf("select2") > -1) {
                    if (description[key].id === index.id){
                        $('#' + fieldPrefix + description[key].id ).val(value);
                    }
                }
            })
        }
    }

    componentDidMount(){
        const $ = window.$;
        this.props.populateModal(true)
        $('.single_ticket').hide();
        $('#ticket_0.single_ticket').show();
        this.declareSelectTipologie();
    }

    declareSelectTipologie = () => {
        const $ = window.$;
        if ($('.select_ticket').data('select2'))
            $(".select_ticket").select2("destroy");

        $(".select_ticket").select2({
            placeholder: common.getTrad("Seleziona un tipo"),
            allowClear: true,
            language: common.getLanguage(),
            minimumResultsForSearch: -1,
            width: '100%',
            dropdownAutoWidth: true
        });

        $('.select_ticket').on('select2:select select2:unselect', (e) => {
            $(".select_ticket").val(e.target.value).trigger("change");
            this.setState({ newTipoTicket: e.target.value });
            let description = this.state.pageContent.BDOCU;
            return description.map((index, key) => {
                $("#" + "modal_old_" + description[key].id).parent("div").removeClass(" colorAlertRed");               
            })
        });
    }

    renderNewForm(){
        const $ = window.$;
        let fieldPrefix = "modal_new_";
        var campiTicket = this.state.tipologie_ticket_attive[this.state.newTipoTicket];
        return campiTicket.campi.map((index, key) => {
            let classNameColTicket = '';
            if (index.id !== 'comments') {
                if (index.id === 'file_multiple')
                    return ('')
                $("label[for='file_multiple'] .danger").hide();
                if (index.titolo != undefined)
                    this.state.indexTitle = true;
                if (index.id === 'mandatory_attachments' || index.id === 'mandatory_attachments_2') {
                    return ('')
                }

                let elemHTML = index.html;
                let description = this.state.pageContent.BDOCU;
                let appoElem = $.parseHTML(index.html);
                let value = description[key].value;
                $(appoElem).attr("id", fieldPrefix + index.id);
                if(description[key].id === index.id){
                    if (index.html.indexOf("textarea") > -1) {
                        $(appoElem).text(value)
                    } else {
                        $(appoElem).attr("value", value)
                    }
                    if (!classNameColTicket.includes(" colorAlertYellow")){
                        classNameColTicket += " colorAlertYellow"                    
                    }
                }else{
                    $("#" + "modal_old_" + description[key].id).parent("div").addClass(" colorAlertRed");
                }               
                elemHTML = appoElem[0].outerHTML;

                return (
                    <div key={key} className={classNameColTicket} id={fieldPrefix + index.id + "_container"}>
                        <div className="form-group">
                            <label htmlFor={index.id}>
                                {this.state.marcaDefault !== undefined || (this.props.marche_attive !== undefined && this.props.marche_attive.length === 1) ? common.getTrad(index.titolo) : index.titolo}
                                &nbsp;{index.html.search("required") > -1 ? <span className="danger">*</span> : ""}
                                {index.tip !== undefined && index.tip !== null && index.tip !== ''  ?
                                    <>&nbsp;<i className="fas fa-info-circle" data-original-title={index.tip} data-toggle="tooltip" data-placement="top"></i>
                                    </>
                                    :
                                    ""
                                }
                            </label>
                            <div dangerouslySetInnerHTML={{ __html: elemHTML }} />
                            <p className={"invalid-feedback labelError_" + index.id}></p>
                        </div>
                    </div>
                )
            } else {
                return ""
            }
        })
        
    }

    closeModal = () => {
        const $ = window.$;
        $('#modalTicket').modal('hide');
        $(".select_ticket").val("").trigger("change");
        this.setState({ newTipoTicket : null})
        let description = this.state.pageContent.BDOCU;
        return description.map((index, key) => {
            $("#" + "modal_old_" + description[key].id).parent("div").removeClass(" colorAlertRed");
        })
    }

    submitChanges = () => {
        const $ = window.$;
        let newDescription = []
        let description = this.state.pageContent.BDOCU;
        let campiTicket = this.state.tipologie_ticket_attive[this.state.newTipoTicket];
        campiTicket.campi.map((index, key) => {
            if (index.id !== undefined) {
                var valore = $('#' + "modal_new_" + index.id).val();
                if (valore !== undefined) {
                    newDescription[key] = {
                        "id" : index.id,
                        "value": valore
                    }
                }else{
                    newDescription[key] = {
                        "id" : index.id,
                        "value": description[key].value
                    }
                }
            }
        });
        let newType = this.state.newTipoTicket
        let newData = {
            "tipo" : newType,
            "description" : newDescription
        }
        this.props.sendData(newData);
        this.closeModal();
    }

    componentDidUpdate(prevProps, nextProps) {
        const $ = window.$;
        this.props.populateModal(true)
        const ticket_type = this.state.newTipoTicket;
        if (!this.state.newTicket && this.state.newTipoTicket && Object.keys(this.state.tipologie_ticket_attive).length > 0) {
            const sub_types = this.state?.tipologie_ticket_attive[ticket_type]['sotto_tipo'];
            if (sub_types) {
                $('#modal_old_tipo_prodotto_new, #modal_new_tipo_prodotto_new').empty();
                $('#modal_old_tipo_prodotto_new, #modal_new_tipo_prodotto_new').append($('<option>', { value: '', text: '' }));
                Object.keys(sub_types).forEach((key) => {
                    let value = sub_types[key];
                    $('#modal_old_tipo_prodotto_new, #modal_new_tipo_prodotto_new').append($('<option>', {
                        value: value['id'],
                        text: value['titolo']
                    }))
                })
            }

            $('#modal_old_tipo_prodotto_new').val(this.state.subType).trigger("change");
        }
        //this.declareSelectTipologie();
        this.changeSelect2Value()
        var inputs = $("#newForm").find("input, textarea, select");
        inputs.on({
            "focusout": function () {
                var targetInput = $(this);
                var appoId = targetInput[0].id + "_container";
                $("#" + appoId).removeClass("colorAlertYellow colorAlertRed");
            },
            "select2:open": function () {
                var targetInput = $(this)
                if(targetInput[0].type === "select-one"){
                    var appoId = targetInput[0].id + "_container";
                    $("#" + appoId).removeClass("colorAlertYellow colorAlertRed");
                }
            },
        });

        if(this.state.newTipoTicket){
            $("#changeType").removeAttr("disabled")
        }else{
            $("#changeType").attr("disabled", true)
        }
    }

    render() {
        var tipologieTicket = this.props.tipologie_ticket_attive;
        
        return (
            <div className="modal fade" id="modalTicket" data-backdrop="static" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-xxl modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{common.getTrad('Modifica tipologia Ticket')}</h5>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-6 col-sm-12">
                                    <h6 className="padding-title">{common.getTrad('Ticket attuale')}</h6>
                                    <label>{common.getTrad("Tipo")}</label>
                                    <input autoFocus autoComplete="off" type="text" required className="form-control" id="typeTicketModal" name="typeTicketModal"
                                        defaultValue={this.state.tipologie_ticket_attive[this.state.pageContent?.CCAUS].titolo} readOnly={true} style={{color: "grey"}}/>
                                    <div className="form-group" style={{ paddingTop: "15px" }}>
                                        {this.props.renderFormTicket(true)}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-12" style={{borderLeft : "1px solid #dee2e6"}}>
                                    <h6 className="padding-title">{common.getTrad('Ticket modificato')}</h6>
                                    <div className="col-12 p-0">
                                        <div className="form-group">
                                            <label>{common.getTrad("Tipo")}</label>
                                            <select className="form-control select2 select_ticket" autoComplete="off" id="select_ticket" onChange={this.handleChangeTipoTicket}>
                                                <option value=""></option>
                                                {
                                                    Object.keys(tipologieTicket).map((key, i) => {
                                                        let value = tipologieTicket[key];
                                                        if (!value.no_insert)
                                                            return (
                                                                <option key={key} value={key}>{value.titolo}</option>
                                                            )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    {this.state.newTipoTicket ?
                                    <div id="newForm">
                                        {this.renderNewForm()}
                                    </div>
                                    :
                                    <></>
                                    }
                                </div>  
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button id="closeModal" type="button" className="btn btn-light" onClick={this.closeModal}>  {common.getTrad('Annulla')}</button>
                            <button id="changeType" type="button" className="btn btn-primary" onClick={this.submitChanges}> {common.getTrad('Conferma')}</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}
export default ChangeTicketType;
